import { Button, Col, List, Row, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { Divider } from 'antd';
import { getIpsStations } from 'api';
import { Form, Input, Checkbox } from 'antd';
import DuplicateBPIDDialog from '../DataTrackTabs/CommonComponent/DialogBox/DuplicateBPIDDialog';
import StationNameSearch from 'containers/common/StationNameSearch';
import { isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';

function AddProjectForm({ setNewProject, addNewProject, project, isModalOpen, handleCancel, goToProject }) {

    const [isNSW, setNSW] = useState(false)
    const [text, setText] = useState("");
    const [stations, setStation] = useState([])
    const [suggestions, setSuggestions] = useState([]);
    const [selectedStation, setSelectedStation] = useState("")
    const [form] = Form.useForm();
    const [isStationBlank, setIsStationBlank] = useState(false)
    const [formDetails, setFormDetails] = useState({});

    const onFinish = (formData) => {

        setIsStationBlank(false)
        setNewProject({ ...formData })
        compareWithEDWData({ ...formData });
        setFormDetails({ ...formData })

    };

    const compareWithEDWData = (formData) => {
        if (formData) {
            addNewProject(formData);
        }

    };

    const clearBPID = () => {
        setFormDetails({ ...formDetails, bpid: "" })
        form.setFieldsValue({ bpid: '' })
        handleCancel();
    }

    async function fetchStaions() {
        if ((stations && stations.length < 1)) {
            const allStations = await getIpsStations({ status: "" });
            setStation(allStations)
        }
    }

    function changeStationName(station) {
        //setSelectedStation(station)
        form.setFieldsValue({ stationName: station })
    }

    useEffect(() => {
        fetchStaions()
    }, [isStationBlank]);


    return (
        <>
            <div className='border-container'>
                <div style={{}}>
                    <DuplicateBPIDDialog show={isModalOpen} handleCancel={handleCancel} goToProject={goToProject} onClickOk={clearBPID} />
                    <Form
                        form={form}
                        labelCol={{
                            span: 10,
                        }}
                        wrapperCol={{
                            span: 14,
                        }}

                        onFinish={onFinish}
                    >
                        <section className='padding-container'>
                            <div className='form-contained-section'>
                                <Row justify='end' align='middle' style={{ paddingBottom: 16 }}>
                                    <Col>
                                        {isIPSDataCreatorOrAdministrator() &&
                                            <button
                                                type='submit'
                                                className='w3-button btn-primary'
                                                htmlType='submit'
                                            >
                                                Save
                                            </button>
                                        }
                                    </Col>
                                </Row>

                                <Row>
                                    <Col
                                        xs={{
                                            span: 24,
                                        }}
                                        sm={{
                                            span: 24,
                                        }}
                                        md={{
                                            span: 24,
                                        }}
                                        lg={{
                                            span: 8,
                                        }}
                                        xxl={{
                                            span: 8,
                                        }}
                                        className={"flexed-column"}
                                    >
                                        <Form.Item
                                            className='form-input-custom-label'
                                            label="IPS Station Name:"
                                            name="stationName"
                                            rules={[{ required: true, message: 'Station Name is required.' }]}
                                        >

                                            <StationNameSearch stations={stations} handleChange={changeStationName} style={{ height: 40, display: 'flex', alignItems: 'center', overflow: 'hidden' }} />
                                        </Form.Item>

                                    </Col>
                                    <Col
                                        xs={{
                                            span: 24,
                                        }}
                                        sm={{
                                            span: 24,
                                        }}
                                        md={{
                                            span: 24,
                                        }}
                                        lg={{
                                            span: 8,
                                        }}
                                        xxl={{
                                            span: 8,
                                        }}>
                                        <Form.Item
                                            className='form-input-custom-label'
                                            label="BPID"
                                            name="bpid"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please enter new BPID!',
                                                },
                                            ]}
                                        >
                                            <Input className='custom-input-width' />
                                        </Form.Item>
                                    </Col>
                                    <Col
                                        xs={{
                                            span: 24,
                                        }}
                                        sm={{
                                            span: 24,
                                        }}
                                        md={{
                                            span: 24,
                                        }}
                                        lg={{
                                            span: 8,
                                        }}
                                        xxl={{
                                            span: 8,
                                        }}
                                    >
                                        <Form.Item
                                            className='form-input-custom-label'
                                            label="Removal BPID"
                                            name="removalBPID"
                                        >
                                            <Input className='custom-input-width' />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col
                                        xs={{
                                            span: 24,
                                        }}
                                        sm={{
                                            span: 24,
                                        }}
                                        md={{
                                            span: 24,
                                        }}
                                        lg={{
                                            span: 8,
                                        }}
                                        xxl={{
                                            span: 8,
                                        }}
                                    ></Col>
                                    <Col
                                        xs={{
                                            span: 24,
                                        }}
                                        sm={{
                                            span: 24,
                                        }}
                                        md={{
                                            span: 24,
                                        }}
                                        lg={{
                                            span: 8,
                                        }}
                                        xxl={{
                                            span: 8,
                                        }}
                                    >
                                        <Form.Item
                                            className='form-input-custom-label'
                                            label="Work Order"
                                            name="workOrder"
                                            rules={[
                                                { required: true, message: 'Work Order is required.' },
                                                { max: 9, message: "Work Order length should be <=9" }]}
                                        >
                                            <Input className='custom-input-width' />
                                        </Form.Item>
                                    </Col>
                                    <Col
                                        xs={{
                                            span: 24,
                                        }}
                                        sm={{
                                            span: 24,
                                        }}
                                        md={{
                                            span: 24,
                                        }}
                                        lg={{
                                            span: 8,
                                        }}
                                        xxl={{
                                            span: 8,
                                        }}>
                                        <Form.Item
                                            className='form-input-custom-label'
                                            label="Removal WO"
                                            name="removalWO"
                                        >
                                            <Input className='custom-input-width' />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>


                        </section>
                    </Form>
                </div>
            </div>
        </>
    );
}


export default AddProjectForm;
